export enum WidgetKeys {
  VolatilityRange = 'volatility-range',
  LatestRealizedVols = 'latest-realized-vols',
  MarketHistory = 'market-history',
  ModelVolatilitySurface = 'model-volatility-surface',
  ScatterPlot = 'scatter-plot',
  TermStructure = 'term-structure',
  TermStructureComparison = 'term-structure-comparison',
  VolSurface = 'vol-surface',
  VolatilitySmile = 'volatility-smile',
  VolSmileComparison = 'vol-smile-comparison',
  VolatilitySurfaceMarking = 'volatility-surface-marking',
  VolSurfaceTimeseries = 'vol-surface-timeseries',
  PerpsTimeseries = 'perps-timeseries',
  FootprintVolatility = 'footprint-volatility',
  OpenInterest = 'open-interest',
  RealizedAndImpliedVols = 'realized-and-implied-vols',
  ImpliedRealizedVolatility = 'implied-realized-volatility',
  VolatilityCones = 'volatility-cones',
  VolatilityHeatmap = 'volatility-heatmap',

  //old keys
  VolSmile = 'vol-smile', //VolatilitySmile
  TokenVolatilityTimeseries = 'token-volatility-timeseries', //RealizedAndImpliedVols
  TokenData = 'token-data', //LatestRealizedVols
}

export interface CustomWidget {
  id?: string;
  key: WidgetKeys;
  title: string;
  noFooter?: boolean;
  isMaximized?: boolean;
}

export const LIST_WIDGETS: CustomWidget[] = [
  { id: WidgetKeys.MarketHistory, key: WidgetKeys.MarketHistory, title: 'Market History' },
  {
    id: WidgetKeys.ModelVolatilitySurface,
    key: WidgetKeys.ModelVolatilitySurface,
    title: 'Model Volatility Surface',
  },
  { id: WidgetKeys.ScatterPlot, key: WidgetKeys.ScatterPlot, title: 'Scatter Plot' },
  { id: WidgetKeys.TermStructure, key: WidgetKeys.TermStructure, title: 'Term Structure' },
  {
    id: WidgetKeys.TermStructureComparison,
    key: WidgetKeys.TermStructureComparison,
    title: 'Term Structure Comparison',
  },
  { id: WidgetKeys.VolSurface, key: WidgetKeys.VolSurface, title: 'Vol Surface' },
  { id: WidgetKeys.VolatilitySmile, key: WidgetKeys.VolatilitySmile, title: 'Vol Smile' },
  {
    id: WidgetKeys.VolSmileComparison,
    key: WidgetKeys.VolSmileComparison,
    title: 'Vol Smile Comparison',
  },
  {
    id: WidgetKeys.VolatilitySurfaceMarking,
    key: WidgetKeys.VolatilitySurfaceMarking,
    title: 'Volatility Surface Marking',
  },
  {
    id: WidgetKeys.VolSurfaceTimeseries,
    key: WidgetKeys.VolSurfaceTimeseries,
    title: 'Vol Surface Timeseries',
  },
  {
    id: WidgetKeys.PerpsTimeseries,
    key: WidgetKeys.PerpsTimeseries,
    title: 'Perps Timeseries',
  },
  {
    id: WidgetKeys.FootprintVolatility,
    key: WidgetKeys.FootprintVolatility,
    title: 'Footprint Volatility Curves',
  },
  { id: WidgetKeys.OpenInterest, key: WidgetKeys.OpenInterest, title: 'Open Interest by Strike' },
  {
    id: WidgetKeys.VolatilityCones,
    key: WidgetKeys.VolatilityCones,
    title: 'Volatility Cones',
  },
  {
    id: WidgetKeys.LatestRealizedVols,
    key: WidgetKeys.LatestRealizedVols,
    title: 'Latest Realized Vols',
  },
  {
    id: WidgetKeys.VolatilityHeatmap,
    key: WidgetKeys.VolatilityHeatmap,
    title: 'Volatility Heatmap',
  },
  { id: WidgetKeys.VolatilityRange, key: WidgetKeys.VolatilityRange, title: 'Volatility Range' },
  {
    id: WidgetKeys.RealizedAndImpliedVols,
    key: WidgetKeys.RealizedAndImpliedVols,
    title: 'Realized and implied Vols',
  },
  {
    id: WidgetKeys.ImpliedRealizedVolatility,
    key: WidgetKeys.ImpliedRealizedVolatility,
    title: 'Implied vs. Realized Volatility',
  },
];
